import { useSelector } from "react-redux";
import { ApplicationState } from "@ppb/tbd-store";

/**
 * URNs the BFF was asked for and returned no card for. Derived from the response, so it covers urns fetched
 * outside the view's own items, but only for typenames the requesting query has a fragment for.
 */
export function useUndeliveredCardUrns(): string[] {
  return useSelector((state: ApplicationState) => state.layouts.undeliveredCardUrns);
}
